<template>
  <div class="container-xxl flex-grow-1 container-p-y">

    <div class="card mb-2">
      <div class="card-datatable">
        <div class="dataTables_wrapper dt-bootstrap5 no-footer">
          <div class="row mx-1" bis_skin_checked="1">
            <div class="col-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-start gap-2"
              bis_skin_checked="1">

              <div class="dataTables_length" id="DataTables_Table_0_length" bis_skin_checked="1">
                <label>Show
                  <select name="DataTables_Table_0_length" aria-controls="DataTables_Table_0" class="form-select">
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </label>
              </div>
              <div class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start" bis_skin_checked="1">
                <div class="dt-buttons btn-group flex-wrap" bis_skin_checked="1">
                  <div class="btn-group" id="dropdown-icon-demo">
                    <button type="button" class="btn btn-info dropdown-toggle" data-bs-toggle="dropdown"
                      aria-expanded="false">
                      <i class="ti ti-upload ti-xs me-2"></i> Export
                    </button>
                    <ul class="dropdown-menu">
                      <li>
                        <a href="javascript:void(0);" class="dropdown-item d-flex align-items-center"><i
                            class="ti ti-printer me-2"></i>Print</a>
                      </li>
                      <li>
                        <a href="javascript:void(0);" class="dropdown-item d-flex align-items-center"><i
                            class="ti ti-file me-2"></i>Csv</a>
                      </li>
                      <li>
                        <a href="javascript:void(0);" class="dropdown-item d-flex align-items-center"><i
                            class="ti ti-file-export me-2"></i>Excel</a>
                      </li>
                      <li>
                        <a href="javascript:void(0);" class="dropdown-item d-flex align-items-center"><i
                            class="ti ti-file-text me-2"></i>Pdf</a>
                      </li>
                    </ul>
                  </div>

                </div>
              </div>
            </div>
            <div
              class="col-12 col-md-5 d-flex align-items-center justify-content-end flex-column flex-md-row pe-5 gap-2 gap-md-4 mt-n2 mb-6 mb-md-0 mt-md-0"
              bis_skin_checked="1">


              <div class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start" bis_skin_checked="1">
                <button class="btn btn-danger waves-effect waves-light" @click="confirmDeleteAllSessions">
                  <span>
                    <i class="ti ti-trash ti-xs me-2"></i>
                    <span>Delete All Sessions</span>
                  </span>
                </button>
              </div>


            </div>
          </div>
          <div class="dataTables_scroll" bis_skin_checked="1">

            <div class="dataTables_scrollBody" bis_skin_checked="1"
              style="position: relative; overflow: auto; width: 100%;">
              <table
                class="dt-scrollableTable table dataTable no-footer table-hover border-top border-bottom dtr-column table-responsive"
                id="DataTables_Table_0" aria-describedby="DataTables_Table_0_info" style="width: 1653px;">
                <thead>
                  <tr class="text-nowrap">
                    <th><input class="form-check-input" type="checkbox" /></th>
                    <th>#</th>
                    <th>MAC Address</th>
                    <th>IP Address</th>
                    <th>Network</th>
                    <th>Interface</th>
                    <th>Usage</th>
                    <th>Session Duration</th>
                    <th>Connect Time</th>
                    <th>Disconnect Time</th>
                  </tr>
                  <tr>
                    <th></th>
                    <th><input type="text" class="form-control form-control-sm" placeholder="Search" /></th>
                    <th><input type="text" class="form-control form-control-sm" placeholder="Search" /></th>
                    <th><input type="text" class="form-control form-control-sm" placeholder="Search" /></th>
                    <th><input type="text" class="form-control form-control-sm" placeholder="Search" /></th>
                    <th><input type="text" class="form-control form-control-sm" placeholder="Search" /></th>
                    <th><input type="text" class="form-control form-control-sm" placeholder="Search" /></th>
                    <th><input type="text" class="form-control form-control-sm" placeholder="Search" /></th>
                    <th><input type="date" class="form-control form-control-sm" /></th>
                    <th><input type="date" class="form-control form-control-sm" /></th>
                  </tr>
                </thead>
                <tbody class="table-border-bottom-0 ">
                  <tr>
                    <td><input class="form-check-input" type="checkbox" /></td>

                    <td>1</td>
                    <td>BC:62:0E:4A:77:B5</td>
                    <td><a href="#">172.16.16.168</a></td>
                    <td>192.168.111.135</td>
                    <td>LAN_9</td>
                    <td>
                      <span class="badge bg-label-info mb-2 me-1">10.4 GB</span>
                      <span class="badge bg-label-danger me-1">978.9 MB</span>
                    </td>
                    <td>
                      <span class="badge bg-warning">10 h 14 m</span>
                    </td>
                    <td>2024-07-06 04:05 am</td>
                    <td>2025-01-02 02:40 pm</td>
                  </tr>

                </tbody>
              </table>
            </div>
          </div>
          <div class="row mx-1" bis_skin_checked="1">
            <div class="col-sm-12 col-md-6" bis_skin_checked="1">
              <div class="dataTables_info" id="DataTables_Table_0_info" role="status" aria-live="polite"
                bis_skin_checked="1">Showing 1 to 10 of 50 entries</div>
            </div>

            <div class="col-sm-12 col-md-6" bis_skin_checked="1">
              <div class="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate"
                bis_skin_checked="1">
                <ul class="pagination">
                  <li class="paginate_button page-item previous disabled" id="DataTables_Table_0_previous">
                    <a aria-controls="DataTables_Table_0" aria-disabled="true" role="link" data-dt-idx="previous"
                      tabindex="-1" class="page-link">
                      <i class="ti ti-chevron-left ti-sm"></i>
                    </a>
                  </li>
                  <li class="paginate_button page-item active">
                    <a href="#" aria-controls="DataTables_Table_0" role="link" aria-current="page" data-dt-idx="0"
                      tabindex="0" class="page-link">1</a>
                  </li>
                  <li class="paginate_button page-item ">
                    <a href="#" aria-controls="DataTables_Table_0" role="link" data-dt-idx="1" tabindex="0"
                      class="page-link">2</a>
                  </li>
                  <li class="paginate_button page-item ">
                    <a href="#" aria-controls="DataTables_Table_0" role="link" data-dt-idx="2" tabindex="0"
                      class="page-link">3</a>
                  </li>
                  <li class="paginate_button page-item ">
                    <a href="#" aria-controls="DataTables_Table_0" role="link" data-dt-idx="3" tabindex="0"
                      class="page-link">4</a>
                  </li>
                  <li class="paginate_button page-item ">
                    <a href="#" aria-controls="DataTables_Table_0" role="link" data-dt-idx="4" tabindex="0"
                      class="page-link">5</a>
                  </li>
                  <li class="paginate_button page-item next" id="DataTables_Table_0_next">
                    <a href="#" aria-controls="DataTables_Table_0" role="link" data-dt-idx="next" tabindex="0"
                      class="page-link">
                      <i class="ti ti-chevron-right ti-sm"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

</script>
